import React, { useState } from 'react';
import BodyContainer from '../ui/BodyContainer';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import GroupSharpIcon from '@material-ui/icons/GroupSharp';
// import Typography from "@material-ui/core/Typography";
import TextFieldComp from '../ui/TextFieldComp';
import GridCenterItem from '../ui/GridCenterItem';
import CustomButton from '../ui/viewEventUi/CustomButton';
import { isInteger, isAlphaNumeric, isAlphabet } from '../regexFuncs';

const useStyles = makeStyles((theme) => ({
  gridOccupy: {
    width: '100%',
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  icon: {
    fill: '#fff',
  },
  inputStyles: {
    height: 25,
    minWidth: 140,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(3),
    flex: 1,
    paddingLeft: 5,
    '& .MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .MuiFormHelperText-root': {
      marginTop: 0,
    },
    // '& .MuiOutlinedInput-notchedOutline': {
    //   borderColor: '#000000',
    // },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: '#000000',
    },
  },
  inputAreaStyles: {
    // height: 25,
    minWidth: 140,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(2.5),
    marginBottom: theme.spacing(3),
    flex: 1,
    paddingLeft: 5,
    '& .MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .MuiFormHelperText-root': {
      marginTop: 0,
    },
    '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: '#000000',
    },
  },
  btnContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  button: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginBottom: theme.spacing(2.5),
    color: '#fff', //D1373F
    backgroundColor: '#008000',
    borderColor: '#008000',
    minWidth: theme.spacing(14),
    borderWidth: theme.spacing(0.2),
    '&:hover': {
      backgroundColor: '#008000',
      borderColor: '#00acc1',
    },
  },
}));

function Contact() {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    description: '',
  });
  const icon = <GroupSharpIcon className={classes.icon} />;

  const handleTextChange = (event) => {
    let value = event.target.value;
    let name = event.target.name;

    switch (name) {
      case 'name':
        if (!isAlphabet(value)) {
          name = '';
          value = '';
        }
        break;

      default:
        name = '';
        value = '';
        break;
    }

    if (name) {
      setFormData((prevState) => {
        return {
          ...prevState,
          [name]: value,
        };
      });
    }
  };

  return (
    <BodyContainer title="Contact" icon={icon}>
      <Grid className={classes.gridOccupy}>
        <Paper elevation={0} className={classes.root}>
          <GridCenterItem>
            <TextFieldComp
              disabled={false}
              name="name"
              label="Name *"
              placeholder="Name"
              value={formData.name}
              onChange={handleTextChange}
              inputStyles={classes.inputStyles}
            />
          </GridCenterItem>
          <GridCenterItem>
            <TextFieldComp
              disabled={false}
              name="subject"
              label="Subject *"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleTextChange}
              inputStyles={classes.inputStyles}
            />
          </GridCenterItem>
          <GridCenterItem>
            <TextFieldComp
              name="description"
              label="Description *"
              placeholder="Description"
              value={formData.description}
              onChange={handleTextChange}
              multiline={true}
              inputStyles={classes.inputAreaStyles}
              required={true}
              minRows={2}
              maxRows={10}
            />
          </GridCenterItem>
          <GridCenterItem>
            <div className={classes.btnContainer}>
              <CustomButton btnStyle={classes.button} btnText={'Send'} />
            </div>
          </GridCenterItem>
        </Paper>
      </Grid>
    </BodyContainer>
  );
}

export default Contact;
